import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class GlcodeQueryCriteriaClass extends BaseCriteriaModel {
  chart_of_acc_guid?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  gl_code_1?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  descr?: Optional<string> = Optional.empty();
}

export class GlcodeCriteriaModelQuery {
  query = '';

  constructor(glcodeCriteriaModel: GlcodeQueryCriteriaClass) {

    if (!glcodeCriteriaModel) {
      return;
    }

    this.query += glcodeCriteriaModel.chart_of_acc_guid.filter(x => x !== '').map(x => '&chart_of_acc_guid=' + x).orElse('');
    this.query += glcodeCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += glcodeCriteriaModel.gl_code_1.filter(x => x !== '').map(x => '&gl_code_1=' + x).orElse('');
    this.query += glcodeCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += glcodeCriteriaModel.descr.filter(x => x !== '').map(x => '&descr=' + x).orElse('');


    this.query += '&status=' + glcodeCriteriaModel.status;
    this.query += '&orderBy=' + glcodeCriteriaModel.orderBy;
    this.query += '&order=' + glcodeCriteriaModel.order;
    this.query += '&offset=' + glcodeCriteriaModel.offset + '&limit=' + glcodeCriteriaModel.limit;
  }
}
